export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
  if (window.posthog?.capture) {
    window.posthog.capture(name, params);
  }
};
